<template lang="html">
  <div class="bill-table-wrapper" v-loading="tableLoading">
    <el-tabs
      type="border-card"
      v-model="statusType"
      @tab-click="handleClick"
      class="tabs-wrapper"
    >
      <el-tab-pane
        :label="item.label"
        v-for="(item, index) in tabsArr"
        :key="index"
        :name="item.value"
        v-if="!(ruleForm.costType === 2 && index === 3)"
      >
        <el-table :data="tableData" :lazy="true" border style="width: 100%">
          <el-table-column fixed="left"  label="操作" align="center">
            <template slot-scope="scope">
              <span class="link-url" @click="showDetail(scope.row)">详情</span>
            </template>
          </el-table-column>
          <el-table-column prop="newStatus" label="账单状态" align="center">
          </el-table-column>
          <el-table-column
            prop="receiptAndPaymentStatus"
            label="收付状态"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="orderNo"
            label="订单号"
            align="center"
            width="220"
          >
          </el-table-column>
          <el-table-column
            prop="accrualBasisNo"
            label="费用号"
            align="center"
            width="220"
          >
          </el-table-column>
          <el-table-column
            prop="startPoint"
            label="起点"
            align="center"
            show-overflow-tooltip
            width="140"
          >
          </el-table-column>
          <el-table-column
            prop="endPoint"
            label="终点"
            align="center"
            show-overflow-tooltip
            width="140"
          >
          </el-table-column>
          <el-table-column prop="subject" label="科目" align="center">
          </el-table-column>
          <el-table-column prop="totalMoney" label="金额" align="center">
          </el-table-column>
          <el-table-column prop="totalWeight" label="重量" align="center">
          </el-table-column>

          <el-table-column prop="" label="时间" align="center" width="160">
            <template slot-scope="scope">
              {{ scope.row.reviewTime | timeFormat }}
            </template>
          </el-table-column>
        </el-table>
        <div class="table-page-wrapper">
          <el-pagination
            layout="prev, pager, next"
            :total="total"
            :current-page="page"
            :hide-on-single-page="true"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 详情弹窗 -->
    <detail-dialog :dialogVisible.sync="detailVisible" :details="details" />
  </div>
</template>

<script>
import detailDialog from "./components/detailDialog";

export default {
  props: {
    ruleForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      tableLoading: true,
      tabsArr: [
        {
          label: "全部",
          value: "-1"
        },
        {
          label: "未出账",
          value: "1"
        },
        {
          label: "已出账",
          value: "2"
        },
        {
          label: "收付中",
          value: "3"
        },
        {
          label: "已收付",
          value: "4"
        }
      ],
      detailVisible: false,
      details: {},
      statusType: "-1",
      accrualBasisNo: this.$route.query.accrualBasisNo
    };
  },
  computed: {},
  created() {
    this.getDataList();
  },
  methods: {
    /**
     * [getDataList description]
     * @param  {[type]}  type === true [表示是父组件调用]
     * @param  {[type]}  type === false [表示当前组件调用]
     */
    async getDataList(type) {
      type && (this.page = 1);
      this.tableLoading = true;
      // TODO: statusType字段还没用进来
      let { createTime, totalMoney, costType } = this.ruleForm;
      let searchData = this.$clearEmptyParams({
        totalMoney,
        createTime,
        ...(this.accrualBasisNo && { accrualBasisNo: this.accrualBasisNo })
      });
      let bool = !!Object.keys(searchData).length;
      let {
        data: { list, count }
      } = await this.$http.get("/shipper/order-shipper/cost-info", {
        params: {
          page: this.page,
          costType,
          statusType: this.statusType,
          ...(bool && { searchData })
        }
      });
      this.tableData = list.map(item => {
        item.startPoint = item.cityFrom + (item.districtFrom || '');
        item.endPoint = item.cityTo + (item.districtTo || '');
        item.totalWeight = item.goods
          .map(childItem => childItem.weight)
          .reduce((total, num) => total + num);
        return item;
      });
      this.total = count;
      this.tableLoading = false;
    },
    currentChange(val) {
      this.page = val;
      this.getDataList();
    },
    showDetail(obj) {
      this.details = obj;
      this.detailVisible = true;
    },
    handleClick() {
      this.getDataList(true);
    }
  },
  watch: {
    "ruleForm.costType"(newVal) {
      if (newVal === 2 && this.statusType === "1") {
        this.statusType = "-1";
      }
      this.getDataList(true);
    },
    "$route.query"(newVal) {
      this.accrualBasisNo = newVal.accrualBasisNo;
      this.getDataList();
    }
  },
  components: {
    detailDialog
  }
};
</script>

<style lang="scss" scoped>
.bill-table-wrapper {
  min-height: calc(100vh - 450px);
  .table-page-wrapper {
    padding-top: 14px;
    display: flex;
    flex-direction: row-reverse;
  }
  .tabs-wrapper {
    min-height: calc(100vh - 450px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/cost/components/costTable/index.vue